import api from './api';
import apiNoHeaders from './apiNoHeaders';
import idbService from './idbService';
import { createProdutoModel } from '../utils/produtoUtils';

// idb store name
const storeName = 'produtos';

// Recurso SQL Api Syclus
const environment = process.env.NODE_ENV;
const configLocal = localStorage.getItem('configPedidos');
const host = configLocal ? JSON.parse(configLocal).host : '';
const apiRequest = environment === 'production' ? api : apiNoHeaders;
const baseURL = environment === 'production' ? `erp?url=${host}` : host;
const endpoint = 'produto';
// const sqlProduto = 7;
// const sqlProdutoUnidadesSaida = 12;

export const produtoService = {
  getProdutos,
  getProdutosAPI,
  // getProdutoUnidadesSaidaAPI,
  getProduto,
  addProduto,
  addProdutos,
  updateProduto,
  compareAndUpdateProdutos
};

function getProdutos() {
  // Fetch indexedDB Items
  // const itemsIndexedDB = await getIndexedDBProdutos();
  // if (itemsIndexedDB.length) return itemsIndexedDB;
  // return getProdutosAPI();
  return getIndexedDBProdutos();
}

async function getProdutosAPI() {
  const response = await apiRequest.post(`${baseURL}/${endpoint}`, {
    campos: [
      "id_produto",
      "numero_produto",
      "produto",
      "qtde_estoque",
      "id_unidade",
      "unidade",
      "preco_venda",
      "unidade_saida"
    ],
    filtros: [
      {
        campo: "id_tipo_produto",
        criterio: "contendo",
        valor: "0, 4"
      },
      {
        campo: "status",
        criterio: "igual",
        valor: "A"
      }
    ]
  }, {
    params: {
      Acao: 'lista'
    }
  });
  const produtosApi = environment === 'production' ? response.data.result || [] : response.data || [];
  
  await compareAndUpdateProdutos(produtosApi);
  await removeInexistentes(produtosApi);
  return getProdutos();
}

function getIndexedDBProdutos() {
  return idbService.getAll(storeName);
}

function getProduto(id) {
  return idbService.getById(storeName, id);
}

// function getProdutoUnidadesSaidaAPI(idProduto) {
//   return apiRequest.get(`${baseURL}/sql/${sqlProdutoUnidadesSaida}?:idProduto=${idProduto}`);
// }

async function compareAndUpdateProdutos(produtos) {
  if (produtos && produtos.length) {
    for (const produto of produtos) {
      const savedProduto = await getProduto(produto.id_produto);
  
      if (!savedProduto) {
        produto.versao_imp = 1;
        await addProduto(produto);
      } else {
        produto.versao_imp = savedProduto.versao_imp ? savedProduto.versao_imp + 1 : 1;
        await updateProduto(produto);
      }
    }
  } else {
    // Limpa os registros do store produtos
    await idbService.clearStore(storeName);
  }
}

async function removeInexistentes(produtosApi) {
  if (produtosApi && produtosApi.length) {
    const idsProdutosApi = produtosApi.map(produtoApi => produtoApi.id_produto);
    const produtosLocal = await idbService.getAll(storeName);
    const produtosInexistentes = produtosLocal.filter(produtoLocal => !idsProdutosApi.includes(produtoLocal.id_produto));
    if (produtosInexistentes && produtosInexistentes.length) {
      for (const produto of produtosInexistentes) {
        await idbService.deleteFromStore(storeName, produto.id_produto);
      }
    }
  } else {
    return;
  }
}

async function addProduto(produto) {
  const parsedProduto = createProdutoModel(produto);
  return idbService.addToStore(storeName, parsedProduto);
}

async function addProdutos(produtos = []) {
  const parsedProdutos = produtos.map(produto => createProdutoModel(produto));
  return idbService.addMultipleToStore(storeName, parsedProdutos);
}

async function updateProduto(produto) {
  const parsedProduto = createProdutoModel(produto);
  await idbService.updateItem(storeName, parsedProduto);
}